'use client';

import Button from '@ui/Button';
import { revalidatePage } from 'actions/server.actions';
import useEditNpoProfileStore from 'components/store/editNpoProfileModalSlice';
import useEditProfileStore from 'components/store/editProfileModalSlice';
import useSticky from 'hooks/useSticky';
import React, { useEffect } from 'react';
import { MdEdit } from 'react-icons/md';

function ProfileEditButton({ userData, profileType = 'user' }) {
  useSticky('about-lane', 80, 20);

  const setShowEditProfileModal = useEditProfileStore((state) => state.setOpen);
  const setShowEditNpoProfileModal = useEditNpoProfileStore((state) => state.setOpen);

  const handleOpen = () => {
    switch (profileType) {
      case 'user':
        setShowEditProfileModal(true, userData, 'Profile Information');
        // revalidatePage('/profile/me');
        break;
      case 'npo':
        setShowEditNpoProfileModal(true, userData);
        // revalidatePage('/nonprofit/[slug]');
        break;
      case 'company':
      default:
        console.log('Invalid profile type');
        break;
    }
  };

  return (
    <div className="">
      <Button variant="icon" onClick={handleOpen} className="bg-white">
        <MdEdit className="h-6 w-6 text-black" />
      </Button>
    </div>
  );
}

export default ProfileEditButton;
